import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-text-marketing',
  templateUrl: './text-marketing.page.html',
  styleUrls: ['./text-marketing.page.scss'],
})
export class TextMarketingPage implements OnInit {

  public tab: string;
 
  constructor (private userService: UserService,
               private router: Router
              // private googleAnalytics: GoogleAnalytics,
          ) { 
    this.tab = 'marketing-composer';
  }

  public ngOnInit () {
  }

  public ionViewCanEnter () {
    if (!this.userService.isLoggedIn()) {
      setTimeout(() => {
        this.router.navigateByUrl('/login');
      }, 100);
      return false;
    }

    return true;
  }
}
